import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { queryPayableDetailStatistics, queryPayableRefunded } from '@api/incubator/payable';
import util from '@util/index';
import ChangeType from './ChangeType';

class TableRefunded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      statis: {},
    };
  }

  componentDidMount() {
    const { billTab, condition } = this.props;
    this.type = billTab.refunedType || '-1';
    this.current = billTab.refunedPage || 1;
    this.pageSize = billTab.refunedPageSize || 10;
    this.condition = condition;
    this.getPayableRefunded();
    this.getPayableDetailStatistics();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.getPayableRefunded();
      this.getPayableDetailStatistics();
    }
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.getPayableRefunded();
      this.getPayableDetailStatistics();
    }
  }

  onChange = e => {
    this.type = e.target.value;
    this.current = 1;
    this.getPayableRefunded();
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getPayableRefunded();
  };

  getPayableRefunded = () => {
    const { pageSize } = this;
    this.setState({
      isLoading: true,
    });
    queryPayableRefunded({
      ...this.condition,
      type: this.type >= 0 ? this.type : '',
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange(this.type, this.current, pageSize);
        this.setState({
          isLoading: false,
          dataSource: {
            list: res.data,
            pagination: {
              pageSize,
              total: res.totalSize,
              current: this.current,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: [10, 20, 50, 100],
            },
          },
        });
      }
    });
  };

  getPayableDetailStatistics = () => {
    queryPayableDetailStatistics({
      tab: 'REFUND',
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
        });
      }
    });
  };

  columns = () => {
    const type = ['押金', '工位收入', '地址收入', '作废', '退款'];
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 150,
        position: 'fixed',
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 300,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 150,
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '待退款',
        dataIndex: 'price',
        width: 150,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
      {
        title: '已退款',
        dataIndex: 'confirm',
        width: 150,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
      {
        title: '款项状态',
        dataIndex: 'payStatus',
        width: 150,
        render: (text, record) => {
          let statusFont = '';
          if (record.price > 0) {
            if (record.confirm > 0) {
              statusFont = '部分匹配';
            } else {
              statusFont = '没有匹配';
            }
          } else {
            statusFont = '完成匹配';
          }
          return <span>{statusFont}</span>;
        },
      },
      {
        title: '实际退款日期',
        dataIndex: 'date',
        width: 200,
        render: (text, record) => (
          <span>{text ? moment.unix(record.date / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statis,
      isLoading,
    } = this.state;
    const { billTab } = this.props;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <ChangeType
            statis={statis}
            onChange={this.onChange}
            defaultValue={billTab.pendingType || '-1'}
            isLoading={isLoading}
            scroll={{ x: true, y: false, scrollToFirstRowOnChange: true }}
          />
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.onTableChange}
          loading={isLoading}
        />
      </div>
    );
  }
}

export default TableRefunded;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableRefunded.js